import { HubSpotDeal } from "../types/hubspot";
import { AuthUser } from "../types/auth";
import { isAssignedToUser } from "./projectAssignments";

export type PersistedProjectScope =
  | "mine"
  | "all"
  | "mine-nacharbeiten"
  | "all-nacharbeiten";

export type ProjectScope = PersistedProjectScope | "search";

const STORAGE_KEY = "360volt-project-scope";

function normalizePersistedScope(raw: string | null): PersistedProjectScope {
  if (raw === "mine" || raw === "mine-nacharbeiten") {
    return "mine";
  }
  if (raw === "all" || raw === "all-nacharbeiten") {
    return "all";
  }
  return "mine";
}

export function getDefaultProjectScope(): PersistedProjectScope {
  if (typeof window === "undefined") {
    return "mine";
  }

  const raw = window.localStorage.getItem(STORAGE_KEY);
  const normalized = normalizePersistedScope(raw);

  // Auf Mobile gibt es nur "Alle Projekte" im UI.
  // Daher erzwingen wir dort einen konsistenten Default.
  if (window.matchMedia("(max-width: 639px)").matches) {
    return "all";
  }

  return normalized;
}

export function persistProjectScope(scope: PersistedProjectScope) {
  if (typeof window === "undefined") {
    return;
  }

  window.localStorage.setItem(STORAGE_KEY, scope);
}

export function isNacharbeitenScope(scope: PersistedProjectScope) {
  return scope === "mine-nacharbeiten" || scope === "all-nacharbeiten";
}

export function isMineScope(scope: PersistedProjectScope) {
  return scope === "mine" || scope === "mine-nacharbeiten";
}

export function matchesProjectScope(
  deal: HubSpotDeal,
  scope: PersistedProjectScope,
  user: AuthUser | null | undefined,
  context?: { hubspotOwnerIds?: string[] }
) {
  if (isMineScope(scope) && !isAssignedToUser(deal, user || null, context)) {
    return false;
  }

  if (isNacharbeitenScope(scope) && !deal.project_status?.nacharbeiten?.hasOpenNacharbeiten) {
    return false;
  }

  return true;
}
